import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteVendorCreationPopupContent.PrimaryInformation', {
    primaryInformationSection: 'Primary information',
    isCompany: 'Company',
    isIndividual: 'Individual',
    vendorType: 'Type',
    companyName: 'Company name',
    webAddress: 'Web address',
    salutation: 'Salutation',
    firstName: 'First name',
    middleName: 'Middle name',
    lastName: 'Last name',
    category: 'Category',
    comments: 'Comments',
    jobTitle: 'Job title',
    inputPlaceholder: 'Enter value',
    selectPlaceholder: 'Select value',
});
